import { useTranslation } from 'react-i18next';
export const useLocale = () => {
  const { t, i18n } = useTranslation();
  return {
    intl: { formatMessage: ({ id }: { id: string }) => t(id) },
    getLocale: () => i18n.language,
    setLocale: (lang: string) => i18n.changeLanguage(lang),
  };
};
